import { render } from "./TheFooter.vue?vue&type=template&id=908b8bfc"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=908b8bfc&lang=css"

import exportComponent from "C:\\Users\\griff\\source\\repos\\Owen Associates\\Owen Associates\\Owen_Interiors\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__